import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import React from 'react';

interface EditSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const EditSwitch: React.FC<EditSwitchProps> = ({ checked, onChange }) => (
  <Checkbox
    checked={checked}
    onChange={(e) => onChange(e.target.checked)}
    inline
  >
    {checked ? 'Ativo' : 'Inativo'}
  </Checkbox>
);

export default EditSwitch; 